import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { UilPlus, UilMinus } from '@iconscout/react-unicons';
import { Text1 } from './common.styles.font';
import { tabletViews } from '../utils/media';
import { mainDetails } from '../data/mainDetails';

const Wrapper = styled.div`
    display: none;

    /* max-width: 820px */
    @media ${tabletViews.lg} {
        display: block;
    }
`;

const Item = styled.div`
    position: relative;
    margin: 3rem 0;

    &:first-of-type::after,
    &::before {
        content: '';
        position: absolute;
        left: 0;
        background: #000;
        width: 100%;
        height: 2px;
    }

    &:first-of-type::after {
        top: -1.6rem;
    }

    &::before {
        bottom: -1.6rem;
    }

    .item-text {
        display: none;
        font-weight: 500;
    }

    &.active .item-text {
        display: block;
        padding-bottom: 1.2rem;
    }

    &.active .icon-collapse,
    .icon-expand {
        display: block;
    }

    &.active .icon-expand,
    .icon-collapse {
        display: none;
    }
`;

const TitleBtn = styled.button`
    width: 100%;
    font-family: 'Roboto Mono', 'Ubuntu', sans-serif;
    text-transform: uppercase;
    font-size: 1.7rem;
    font-weight: 500;
    margin-bottom: 1.6rem;
    padding-right: 0.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Arrows = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
        width: 1.8rem;
        height: 1.8rem;
    }
`;

interface Props {
    curLang: string;
}

const CollapseList: React.FC<Props> = ({ curLang }) => {
    const { t } = useTranslation();

    return (
        <Wrapper className="challenges-collapse">
            {mainDetails.challenge.map(({ id, title, txt }) => (
                <Item key={id}>
                    <TitleBtn
                        className="chal-item-btn"
                        onClick={(e) => {
                            const target = e.target as HTMLElement;
                            if (target.parentNode) {
                                const parent = target.parentNode as HTMLElement;
                                parent.classList.toggle('active');
                            }
                        }}
                    >
                        <span>{t(title)}</span>
                        <Arrows>
                            <UilPlus className="icon icon-expand" />
                            <UilMinus className="icon icon-collapse" />
                        </Arrows>
                    </TitleBtn>

                    <Text1 className={`lang-${curLang} item-text`}>
                        {t(txt)}
                    </Text1>
                </Item>
            ))}
        </Wrapper>
    );
};

export default CollapseList;
